<template>
  <div ref="container" class="tw-relative">
    <button v-if="false" @click="isActive = !isActive" class="tw-w-[40px] tw-h-[40px] tw-rounded-lg tw-border-b-2 tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200">
      <img src="https://themewagon.github.io/themekit/img/users/1.jpg" class="tw-w-[40px] tw-h-[40px] tw-object-cover" />
    </button>

    <a-button  @click="isActive = !isActive" icon="solar:user-broken" intent="icon" icon-class="!tw-text-2xl" class="tw-rounded-lg"></a-button>


    <transition
      class="tw-duration-200"
      enter-from-class="tw-translate-y-[10px]  tw-opacity-0"
      leave-to-class="tw-translate-y-[10px]  tw-opacity-0"
    >
      <div v-if="isActive">
        <div
          :class="[$root.$i18n.locale == 'ar' ? 'tw-left-0' : 'tw-right-0']"
          class="tw-w-fit tw-min-w-[200px] tw-shadow-md tw-max-w-[250px] tw-overflow-hidden tw-absolute -tw-bottom-1 tw-translate-y-full tw-bg-white tw-rounded-lg tw-border tw-border-b-2"
        >
          <div class="tw-w-full tw-pb-3">
            <div class="tw-flex tw-gap-2 tw-p-2 tw-items-center tw-pb-2 tw-border-b tw-border-gray-100">
              <div class="tw-w-[45px] tw-h-[45px] tw-rounded-full tw-overflow-hidden tw-bg-gray-100 tw-border-2 tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-center">
                <img 
                  v-if="hasUserProfileImage" 
                  :src="authStore.user.profile_image" 
                  :alt="`${visibleName} profile`" 
                  class="tw-w-full tw-h-full tw-object-cover"
                  @error="handleImageError"
                >
                <icon 
                  v-else 
                  icon="solar:user-bold-duotone" 
                  class="tw-text-gray-400 tw-text-2xl"
                />
              </div>

              <div class="tw-py-1">
                <h2 class="tw-text-gray-600 tw-font-semibold tw-whitespace-nowrap tw-truncate tw-text-sm">{{ visibleName }}</h2>
                <h3 class="tw-font-semibold tw-whitespace-nowrap tw-truncate tw-text-xs tw-px-1 tw-w-fit tw-rounded-sm tw-mt-0.5 tw-bg-blue-100 tw-text-blue-500 tw-capitalize">{{ authStore.user.role }}</h3>
              </div>
            </div>

            <div class="tw-w-full tw-mt-3">
              <button @click="isActive = false" class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                <icon class="tw-text-xl tw-text-gray-500" icon="solar:user-circle-bold-duotone" />
                <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.my-account') }}</span>
              </button>

              <button @click="visible.roles = !visible.roles" v-if="authStore.user.roles.length > 1" class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <icon class="tw-text-xl tw-text-gray-500" icon="solar:shield-user-bold-duotone" />
                  <span class="tw-text-gray-500 tw-text-sm tw-font-medium">{{ $t('buttons.act_as', 'Act as') }}</span>
                </div>
                
                <icon class="tw-text-xl tw-text-gray-400 tw-duration-200" :class="[visible.roles && 'tw-rotate-90']" :icon="loading.actAsRole ? 'line-md:loading-alt-loop' : 'majesticons:chevron-right'" />
              </button>

              <div v-if="visible.roles && authStore.user.roles.length > 1" class="tw-border-y tw-border-solid tw-border-gray-200">
                <button v-for="role in authStore.user.roles" :key="role.id" 
                @click="handleActAsRole(role)"
                :class="[role.toLowerCase() == authStore.user.role.toLowerCase() && '!tw-text-primary-500']"
                class="tw-flex tw-items-center tw-gap-2 tw-p-2 tw-px-5 tw-text-gray-500 hover:tw-bg-primary-50 tw-duration-200 tw-w-full tw-cursor-pointer">
                  <span 
                  
                  class=" tw-text-sm tw-font-medium tw-capitalize">{{ role }}</span>
                  <icon v-if="role.toLowerCase() == authStore.user.role.toLowerCase()" class="tw-text-sm tw-text-primary-400" icon="uis:check-circle" />
                </button>
              </div>

              <button :disabled="isLogginOut" @click="handleLogout" 
              :class="[isLogginOut && '!tw-text-gray-300 !tw-bg-gray-50']"
              class="tw-flex tw-items-center tw-gap-2 tw-text-red-500 tw-p-2 tw-px-5 hover:tw-bg-gray-50 tw-duration-200 tw-w-full">
                <icon class="tw-text-xl" :icon="isLogginOut ? 'line-md:loading-alt-loop' : 'solar:logout-3-bold-duotone'" />
                <span class="tw-text-sm tw-font-medium">{{ $t('buttons.logout') }}</span>
              </button>
            </div>
          </div>
      </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { onClickOutside } from "@vueuse/core";
import { formatFullName } from '@/utils/string'
import { useAuthStore } from "@/stores";
import { useRouter } from "vue-router";
import { logout, actAsRole } from '@/api/auth'

const isActive = ref(false);
const container = ref(null);
const authStore = useAuthStore();
const router = useRouter();
const isLogginOut = ref(false);
const visible = ref({
  roles: false
})

const loading = ref({
  actAsRole: false
})

const visibleName = computed(() => formatFullName(authStore.user.name));
const hasUserProfileImage = computed(() => {
  return authStore.user.profile_image && authStore.user.profile_image.length > 0;
});

onClickOutside(container, () => (isActive.value = false));

const handleLogout = async () => {
  isLogginOut.value = true;
  await logout();
  
  authStore.logout();
  router.push({ name: 'auth.login' });
  isLogginOut.value = false;
}

const handleImageError = () => {
  // Handle image loading error - the v-if will automatically show the icon fallback
};

const handleActAsRole = async (role) => {
  visible.value.roles = false;
  loading.value.actAsRole = true;
  await actAsRole(role)
  .then((res) => {
    if(res.status == 200) {
      authStore.user.role = role;
      router.push({ name: 'home' });
    }
  })
  .catch((err) => {
    console.log(err);
  })
  loading.value.actAsRole = false;

}
</script>

<style>
</style>